// extracted by mini-css-extract-plugin
export default {"result":"style_result__bXYqH","cup":"style_cup__tTKq5","time":"style_time__eoACL","active":"style_active__L1ca6"};